import { DatePicker, Form } from 'antd'
import { DEFAULT_DATE_FORMAT, formatDate, toDatePickerValue } from '../../../../utils/safeDate.js'


const DateForm = (props) => {
    const { values, disabled = false, parent = "", tableLabel = "", dateFormat } = props
    const currentDateFormat = dateFormat || DEFAULT_DATE_FORMAT

    // Cell values come from the form store, so they can be an ISO string, a live
    // dayjs, or a dayjs that lost its prototype on a redux/IndexedDB round trip.
    // toDatePickerValue absorbs all of those and gives null for anything unusable,
    // so the picker renders empty instead of throwing or showing "Invalid Date".
    const currentValue = toDatePickerValue(values?.[props.id], currentDateFormat)

    // A format without a day (MMMM-YYYY / MMM) needs the month panel and a
    // year-only format needs the year panel, otherwise the day picker produces
    // values the format cannot round-trip.
    const picker = currentDateFormat === "YYYY"
        ? "year"
        : !currentDateFormat.includes("D")
            ? "month"
            : "date"

    if (disabled) {
        return <span>{formatDate(values?.[props.id], currentDateFormat)}</span>
    }

    return (
        <Form.Item label="" preserve={false} style={{ marginBottom: 0 }}>
            <DatePicker
                picker={picker}
                format={currentDateFormat}
                disabled={disabled}
                value={currentValue}
                onChange={(e) => props.handleChange(props.id, e, props.documentId)}
            />
        </Form.Item>
    )
}

export default DateForm
